export type EditorPos = { from: number; to: number };

/** Snapshot the current selection. Call this on pointer-down of a menu/dialog
 *  trigger, before the editor blurs. */
export function captureEditorPos(editor: any): EditorPos | null {
    if (!editor) return null;
    const { from, to } = editor.state.selection;
    return { from, to };
}

/** Insert at a captured selection (or the editor's current one). Avoids
 *  `focus()`-first inserts, which land at the start/end after a blur. */
export function insertAtPos(
    editor: any,
    content: unknown,
    pos: EditorPos | number | null | undefined,
): void {
    if (!editor || content == null) return;
    const size = editor.state.doc.content.size;
    const range = typeof pos === "number"
        ? { from: pos, to: pos }
        : pos ?? { from: editor.state.selection.from, to: editor.state.selection.to };
    const from = Math.max(0, Math.min(range.from, size));
    const to = Math.max(from, Math.min(range.to, size));
    editor.chain().insertContentAt({ from, to }, content).focus().run();
}
